import { Theme } from "@mui/material";
import { SystemStyleObject } from "@mui/system";

export const classes: Record<string, SystemStyleObject<Theme>> = {
  toolbar: {
    display: "flex",
    justifyContent: "space-between",
    paddingBottom: ({ spacing }) => ({ xs: spacing(2), sm: spacing(8) }),
    paddingTop: ({ spacing }) => spacing(4),

    position: { xs: "sticky", sm: "initial" },
    backgroundColor: "background.default",
    top: -32,
    zIndex: 10,
    boxShadow: { xs: "0px 35px 25px -21px rgb(9 9 9)", sm: "none" },

    paddingLeft: ({ spacing }) => ({ xs: spacing(2), sm: spacing(4) }),
    paddingRight: ({ spacing }) => ({ xs: spacing(2), sm: spacing(4) }),

    marginLeft: ({ spacing }) => ({ xs: spacing(-2), sm: spacing(-4) }),
    marginRight: ({ spacing }) => ({ xs: spacing(-2), sm: spacing(-4) }),

    marginTop: ({ spacing }) => ({ sm: 0, xs: spacing(-4) }),
  },

  actions: {
    display: "flex",
    alignItems: "center",
    gap: ({ spacing }) => spacing(2),
    // flexWrap: "wrap-reverse",
  },

  counter: {
    display: "flex",
    alignItems: "center",
    gap: ({ spacing }) => spacing(1),
    color: "text.secondary",
    whiteSpace: "nowrap",
    marginRight: ({ spacing }) => spacing(1),
  },

  label: {
    fontWeight: "600",

    fontSize: { xs: "2rem", sm: "3rem" },
  },

  backButton: {
    display: "flex",
    gap: ({ spacing }) => spacing(1),
    cursor: "pointer",
    marginRight: "auto",
  },

  counterWrapper: {
    display: "flex",
    justifyContent: "space-between",
  },
};
